import { lazy } from "react";
import Loadable from "components/Loadable";

//HOMEPAGE
const HomePage = Loadable(lazy(() => import("pages/public/homepage/HomePage")));
const HomePageSkelton = Loadable(lazy(() => import("pages/public/homepage/HomePageSkelton")));

//CATEGORIES LISTS
const CategoriesList = Loadable(lazy(() => import("pages/public/categories/CategoriesList")));

//TOP VENUS LISTS
const TopVenusList = Loadable(lazy(() => import("pages/public/topVenues/TopVenuesList")));

//VENUS LISTS
// const VenueAdd = Loadable(lazy(() => import("pages/public/venue/VenueAdd")));
const VenueList = Loadable(lazy(() => import("pages/public/venue/VenueList")));
const VenueDetail = Loadable(lazy(() => import("pages/public/venue/VenueDetails")));
const VenueCheckout = Loadable(lazy(() => import("pages/public/venue/Checkout")));
const VenueReviewList = Loadable(lazy(() => import("pages/public/venue/VenueReviewList")));

// Services 
const ServiceList = Loadable(lazy(() => import("pages/public/services/ServiceList")));
const ServiceCard = Loadable(lazy(() => import("pages/public/services/ServiceCard")));

const ServiceDetails = Loadable(lazy(() => import("pages/public/services/ServiceDetails")));
const ServiceReviewList = Loadable(lazy(() => import("pages/public/services/ServiceReviewList")));


const ModalButton = Loadable(lazy(() => import("pages/public/homepage/Modal")));



// CMS_PAGE
const CMSPageView = Loadable(lazy(() => import("pages/public/cms-page/View")));
const ContactUS = Loadable(lazy(() => import("pages/public/cms-page/ContactUS")));


const publicRoutes = [

  { path: "*", element: <HomePage /> },

  
  { path: "/", element: <HomePage /> },
  { path: "/HomePageSkelton", element: <HomePageSkelton /> },
  { path: "/venue/top-categories", element: <CategoriesList /> },
  { path: "/venue/top-locations", element: <TopVenusList /> },
  // { path: "/venue/add", element: <VenueAdd /> },
  { path: "/venues", element: <VenueList /> },
  { path: "/bids", element: <VenueList /> },
  { path: "/venue/info/:id", element: <VenueDetail /> },
  { path: "/venue/:id/checkout", element: <VenueCheckout /> },
  { path: "/venue/info/:id/review", element: <VenueReviewList /> },
  { path: "/ancilliaryservices", element: <ServiceList /> },
  { path: "/ancilliaryservice/card", element: <ServiceCard /> },

  { path: "/ancilliaryservices/info/:id", element: <ServiceDetails /> },
  { path: "/ancilliaryservices/:id/review", element: <ServiceReviewList /> },

  { path: "/modal-button", element: <ModalButton /> },


   //cms-page
  { path: "/page/:slug", element: <CMSPageView /> },
  { path: "/contact-us", element: <ContactUS /> },


];

export default publicRoutes;
